import React from 'react';
import StudentHeader from '@/components/student/StudentHeader';


const StudentCourses = () => {
  return (
    <div className="min-h-screen bg-slate-50">
      <StudentHeader />
      <div className="max-w-7xl mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold mb-6">StudentCourses</h1>
        <p>Content under development.</p>
      </div>
      
    </div>
  );
};

export default StudentCourses;
